/**
 * Rausgegangen's external-loader.js expects exactly one script#purchase-widget-loader.
 * With multiple ticket drawers on a page, inject that script only when a drawer opens.
 */
function createLoaderEl() {
  const wrap = document.createElement('div');
  wrap.className = 'rg-purchase-loader';
  wrap.setAttribute('role', 'status');
  wrap.setAttribute('aria-live', 'polite');
  wrap.setAttribute('aria-label', 'Loading');
  const spin = document.createElement('div');
  spin.className = 'rg-purchase-loader__spinner';
  spin.setAttribute('aria-hidden', 'true');
  wrap.appendChild(spin);
  return wrap;
}

function scheduleHideLoader(loader, container) {
  const minVisibleUntil = Date.now() + 450;
  let settled = false;

  const finish = () => {
    if (settled) {
      return;
    }
    settled = true;
    const wait = Math.max(0, minVisibleUntil - Date.now());
    window.setTimeout(() => {
      loader.classList.add('rg-purchase-loader--done');
      window.setTimeout(() => loader.remove(), 300);
    }, wait);
  };

  const hasWidgetContent = () => {
    const scriptEl = document.getElementById('purchase-widget-loader');
    return [...container.children].some((el) => el !== loader && el !== scriptEl);
  };

  let maxWait = null;

  const obs = new MutationObserver(() => {
    if (hasWidgetContent()) {
      if (maxWait != null) {
        window.clearTimeout(maxWait);
      }
      obs.disconnect();
      finish();
    }
  });
  obs.observe(container, { childList: true, subtree: true });

  maxWait = window.setTimeout(() => {
    obs.disconnect();
    finish();
  }, 12000);

  if (hasWidgetContent()) {
    if (maxWait != null) {
      window.clearTimeout(maxWait);
    }
    obs.disconnect();
    finish();
  }
}

export function initRausgegangenPurchaseWidget() {
  document.addEventListener('change', (e) => {
    const toggle = e.target;
    if (!(toggle instanceof HTMLInputElement) || !toggle.matches('.js-rg-ticket-drawer .tw-drawer-toggle')) {
      return;
    }

    const drawer = toggle.closest('.js-rg-ticket-drawer');
    if (!drawer) {
      return;
    }

    const container = drawer.querySelector('.purchase-widget-container[data-rg-src]');
    const src = container?.getAttribute('data-rg-src');
    const layout = container?.getAttribute('data-rg-layout') || 'fullwidth';

    if (toggle.checked) {
      if (!src || !container) {
        return;
      }

      document.getElementById('purchase-widget-loader')?.remove();

      document.querySelectorAll('.purchase-widget-container[data-rg-src]').forEach((el) => {
        el.innerHTML = '';
      });

      const loader = createLoaderEl();
      container.appendChild(loader);

      const script = document.createElement('script');
      script.id = 'purchase-widget-loader';
      script.src = src;
      script.setAttribute('data-cart-enabled', 'true');
      script.setAttribute('data-layout', layout);

      script.addEventListener('load', () => {
        scheduleHideLoader(loader, container);
      });

      script.addEventListener('error', () => {
        loader.classList.add('rg-purchase-loader--done');
        window.setTimeout(() => loader.remove(), 300);
      });

      container.appendChild(script);
    } else {
      document.getElementById('purchase-widget-loader')?.remove();
      if (container) {
        container.innerHTML = '';
      }
    }
  });
}
